<template>
  <slot />
</template>

<script setup lang="ts">
import type { FooterNavigationApiModel } from '@gro-up/api/corporate'
import type { Domain } from '@gro-up/types'
import { provide, ref } from 'vue'

import { useAsyncData, createError } from '#app'

const { data, error } = await useAsyncData<FooterNavigationApiModel>('layout', async () =>
  $fetch<FooterNavigationApiModel>('/api/content/layout'),
)

if (error.value) {
  console.error('Error fetching layout data:', error.value)
  throw createError({
    statusCode: 500,
    message: error.value?.message,
    fatal: true,
  })
}

provide('layoutData', data.value)

// Provide a default domain for components that need it
// Corporate app defaults to head-office domain
const defaultDomain = ref<Domain>('head-office')
provide('domain', defaultDomain)
</script>